var map = {
	"./blog.yml": 97,
	"./cloud.yml": 98,
	"./color.yml": 99,
	"./country.yml": 100,
	"./dio.yml": 101,
	"./doc.yml": 102,
	"./emoji.yml": 103,
	"./git.yml": 104,
	"./icon.yml": 105,
	"./license.yml": 106,
	"./link.yml": 107,
	"./metrics.yml": 108,
	"./people.yml": 109,
	"./soft.yml": 110,
	"./src.yml": 111,
	"./status.yml": 112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96;